var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    y: 0.283203,
    width: 24,
    height: 24.05,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7301 6.29688H12.2699L13.3483 6.30701L14.2581 6.32286L15.6209 6.36108L16.6571 6.40615L17.3127 6.44553C18.0503 6.49623 18.6769 6.56413 19.0324 6.65506C19.807 6.8526 20.4168 7.43465 20.6238 8.1738C20.7358 8.5725 20.8144 9.10012 20.8697 9.64461L20.9115 10.1128L20.9433 10.5736L20.9751 11.2166L20.9951 11.9016L20.9995 12.3996L20.9951 12.7155L20.9751 13.4005L20.9433 14.0435L20.9115 14.5043L20.8697 14.9725C20.8144 15.517 20.7358 16.0447 20.6238 16.4434C20.4168 17.1825 19.807 17.7645 19.0324 17.9622C18.7276 18.0401 18.2238 18.1011 17.6216 18.1488L16.9903 18.1923C16.8809 18.1989 16.7697 18.2051 16.6571 18.211L15.6209 18.2561L14.2581 18.2943L12.8373 18.3161L11.5713 18.3194L10.6517 18.3101L9.74185 18.2943L8.3791 18.2561L7.34282 18.211L6.68721 18.1716C5.94966 18.1209 5.32306 18.0531 4.96752 17.9622C4.19301 17.7645 3.58305 17.1825 3.37605 16.4434C3.26413 16.0447 3.18552 15.517 3.1303 14.9725L3.08847 14.5043L3.05672 14.0435L3.02493 13.4005L3.00486 12.7155L3.00046 12.3996L3.00486 11.9016L3.02493 11.2166L3.05672 10.5736L3.08847 10.1128L3.1303 9.64461C3.18552 9.10012 3.26413 8.5725 3.37605 8.1738C3.58305 7.43465 4.19301 6.8526 4.96752 6.65506C5.27227 6.57712 5.77617 6.5161 6.37837 6.46833L7.00962 6.42483C7.11904 6.41828 7.23027 6.41205 7.34282 6.40615L8.3791 6.36108L9.74185 6.32286L11.1627 6.30103L11.7301 6.29688ZM10.1591 9.77081V14.8463L14.8636 12.3087L10.1591 9.77081Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.792ff6b46ba234e43696b61cc822e163.svg";
export { ForwardRef as ReactComponent };